define('viewmodels/site/__subrouter',['lodash', 'plugins/router', './__guardRoute'],
    function(_, router, sentry) {
        'use strict';
        var parentHash = '#site';
        var childRouter = router.createChildRouter()
            .makeRelative({
                moduleId: 'viewmodels/site',
                fromParent: true
            }).map([ {
                route: 'logout',
                title: 'Logout',
                moduleId: 'logout',
                hash: parentHash + '/logout',
                nav: true,
                visible: false,
                guard: sentry.logout
            }, {
                route: 'error',
                title: 'Error',
                moduleId: 'error',
                hash: parentHash + '/error',
                nav: true,
                visible: false,
                guard: sentry.error
            }, {
                route: 'failure(/:msgId)',
                title: 'Failure',
                moduleId: 'failure',
                hash: parentHash + '/failure',
                nav: true,
                visible: false,
            }]).buildNavigationModel();

        childRouter.guardRoute = guardRoute;

        return childRouter;

        function guardRoute(routeInfo, params) {
            var returnVal = true;
            if (_.isFunction(params.config.guard)) {
                returnVal = params.config.guard();
            }
            return returnVal;
        }
    });
